import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';

import { BaseFormList, ConfigService, MessageService } from '../../../core';
import { ConfigCotacaoItemFormularioIndicador, getItemFormularioIndicador } from '../../configuracoes/app/cotacao';
import { UnidadeNegocioNaturezaVenda } from './unidade-negocio-natureza-venda';
import { NaturezaVenda, naturezaVendaAtiva, NaturezaVendaNomePipe, NaturezaVendaTypeaheadComponent } from '../../natureza-venda';

@Component({
    selector: 'sgt-unidade-negocio-natureza-venda',
    templateUrl: './unidade-negocio-natureza-venda.component.html',
    styleUrls: ['./unidade-negocio-natureza-venda.component.less']
})
export class UnidadeNegocioNaturezaVendaComponent implements BaseFormList<UnidadeNegocioNaturezaVenda>, OnInit {
    @Input() entities: UnidadeNegocioNaturezaVenda[];

    // Naturezas de Vendas
    naturezaVendaSituacaoAtiva = naturezaVendaAtiva.id;
    @ViewChildren('naturezaVendaTypeahead') naturezasVendasTypeaheads: QueryList<NaturezaVendaTypeaheadComponent>;

    // Formulários dos Itens da Cotação
    itensFormulariosCotacao: ConfigCotacaoItemFormularioIndicador[] = [];

    constructor(private configService: ConfigService,
                private messageService: MessageService,
                private naturezaVendaNomePipe: NaturezaVendaNomePipe) { }

    ngOnInit() {
        this.createItensFormulariosCotacao();
    }

    /** Cria as opções dos Formulários dos Itens da Cotação para selecionar e vincular na Unidade de Negócio e Natureza Venda */
    private createItensFormulariosCotacao(): ConfigCotacaoItemFormularioIndicador[] {
        const configCotacao = this.configService.getCotacao();
        if (!configCotacao || !configCotacao.itensFormularios) {
            return [];
        }

        this.itensFormulariosCotacao = [];
        configCotacao.itensFormularios.forEach(itemFormulario => {
            const indicador = getItemFormularioIndicador(itemFormulario.formulario);
            if (indicador) {
                this.itensFormulariosCotacao.push(indicador);
            }
        });
    }

    /** Ao alterar a natureza de venda */
    onChangeNaturezaVenda(entity: UnidadeNegocioNaturezaVenda, naturezaVenda: NaturezaVenda) {
        if (!entity) {
            return;
        }

        entity.idNaturezaVenda = naturezaVenda?.id ?? null;
    }

    insert() {
        const entity = new UnidadeNegocioNaturezaVenda();
        this.entities.push(entity);

        setTimeout(() => this.naturezasVendasTypeaheads?.last?.setFocus(), 200);
    }

    delete(index: number) {
        if (index <= -1) {
            return;
        }
        const entity = this.entities[index];
        this.messageService.confirm(`Deseja realmente excluir a natureza de venda ${this.naturezaVendaNomePipe.transform(entity?.naturezaVenda?.nome, entity?.naturezaVenda?.codigoIntegracaoErp)} da unidade de negócio?`).then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Verifica as naturezas de vendas estão válidos */
    isValid(): boolean {
        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];
            if (!entity.idNaturezaVenda) {
                continue;
            }
            const count = this.entities.filter(entityFilter => entityFilter.idNaturezaVenda && entityFilter.idNaturezaVenda === entity.idNaturezaVenda).length;
            if (count > 1) {
                this.messageService.info(`A natureza de venda ${this.naturezaVendaNomePipe.transform(entity?.naturezaVenda?.nome, entity?.naturezaVenda?.codigoIntegracaoErp)} já está adicionada na unidade de negócio. Remova ou altere a natureza de venda duplicada`, 'Não é possível adicionar duas naturezas de vendas iguais na mesma unidade de negócio');
                return false;
            }
        }
        return true;
    }


    /** Resolve as naturezas de vendas presentes na Unidade de Negócio */
    resolve() {
        if (!this.entities) {
            return;
        }

        // Removendo os itens do array que não possuirem o ID da natureza de venda informada
        for (let i = this.entities.length; i--; ) {
            const entity = this.entities[i];
            if (!entity.idNaturezaVenda) {
                this.entities.splice(i, 1);
            }
        }
    }

}
